import { render, staticRenderFns } from "./editBenefitCategory.vue?vue&type=template&id=430025e6&"
import script from "./editBenefitCategory.vue?vue&type=script&lang=js&"
export * from "./editBenefitCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports